import { render, staticRenderFns } from "./PlayerHeader.vue?vue&type=template&id=2cb9d93a&scoped=true&"
import script from "./PlayerHeader.vue?vue&type=script&lang=js&"
export * from "./PlayerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHeader.vue?vue&type=style&index=0&id=2cb9d93a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9d93a",
  null
  
)

export default component.exports